const ProjectList = [
    {
        id: 1,
        title: "Task List",
        used: "Web Application developed using React JS, Node JS and Mongo DB",
        description: "This web application displays the tasks to perform in a list. It contains the features of create, read, update and delete tasks using MongoDB as database. It includes the feature of searching the tasks.",
        webUrl: "https://task-list-tanish.netlify.app/",
        githubRepo: "https://github.com/venkatasaitanish/task_list"
    },
    
    {
        id: 2,
        title: "Codeforces Data Visualizer",
        used: "Web Application developed mainly using React JS.",
        description: "This web application visualizes codeforces data analytics of a single user and also compares data of 2 users. Used axios to fetch data from Codeforces API. Used chart.js and react-chartjs-2 for graphical representation of data.",
        webUrl: "https://codeforces-data-visualizer-tan.netlify.app/",
        githubRepo: "https://github.com/venkatasaitanish/Codeforces-Data-Visualizer"
    },

    {
        id: 3,
        title: "HTML-CSS-JS Editor",
        used: "Web Application developed mainly using React JS.",
        description: "This web appplication is useful to work and edit with HTML, CSS and Javascript codes. It preview the changes immedialtely similar to Codepen and JSFiddle. This is done by using Codemirror text editor NPM package. Used Local storage to save the code and retrieve it later in future.",
        webUrl: "https://html-css-js-editor.netlify.app/",
        githubRepo: "https://github.com/venkatasaitanish/HTML-CSS-JS-Editor"
    },
    
    {
        id: 4,
        title: "Text to Speech Converter",
        used: "Web Appplication using HTML, CSS, Javascript and Bootstrap.",
        description: "This web application converts the input text into speech by the voices present in the system. This is done using the WebSpeech API of Javascript.",
        webUrl: "https://venkatasaitanish.github.io/Text-to-Speech-Converter/",
        githubRepo: "https://github.com/venkatasaitanish/Text-to-Speech-Converter"
    },
]

export default ProjectList;